export default {
  autoLoan: '🚗',
  creditCard: '💳',
  medical: '👩‍⚕️',
  mortgage: '🏠',
  other: '🚨',
  personalLoan: '💰',
  studentLoan: '🎓'
};



// WEBPACK FOOTER //
// ./src/constants/emojis.js